export default {
    ADD_AREA_MODAL_SHOW: 'ADD_AREA_MODAL_SHOW',
    ADD_AREA_MODAL_HIDE: 'ADD_AREA_MODAL_HIDE',
};
